module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "structure-sub"
  }, [_vm._v("Contents"), _c('span', {
    staticClass: "normal-caps2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_004#b1"
    }
  }, [_vm._v("Foreword by Bestselling Author Peter Walsh")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_007#b2"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "id": "a3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_011#b3"
    }
  }, [_vm._v("What ClutterBug are You?")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "id": "a4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_019#b4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Minutes a Day Keeps the Clutter Away")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "id": "a5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_024#b5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Painless Purging with the 21 Item Toss ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "id": "a6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_029#b6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Find the Valuable Real Estate in Your Home")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "id": "a7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_031#b7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contain the Clutter - The Secret to Organization")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "id": "a8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_042#b8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Burden of Guilty Clutter")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "id": "a10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_044#b9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Routines, To-Dos and Checklists - Oh My!")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "id": "a11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_049#b10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Favorite Organizing Tips")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "id": "a12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_051#b11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Organizing for Small Children")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "id": "a13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_056#b12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bloom Where You are Planted")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_061#Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_063#b13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/RealLifeOrg_split_065#b14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planner")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_2"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-372aa1da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/RealLifeOrg_split_002.vue
// module id = 63
// module chunks = 0